import React from 'react';
import { getI18n } from 'react-i18next';
import TableHeader from '~/pages/agent/components/agent/tableElements/TableHeader';
import { CellText } from '~/pages/agent/components/agent/tableElements/cells/CellText';
import longdash from '~/constants/longdash';

function getApplicationId(record: Record<string, unknown>) {
  return (record.applicationId ?? record.applicationDisplayId) as string | undefined;
}

function applicationIdCell(visibleColumns: string[]) {
  if (!visibleColumns.includes('applicationId')) {
    return null;
  }

  return {
    title: () => (
      <TableHeader
        title={getI18n().t('Application ID', { ns: 'agent' })}
        sortingDataKey="applicationId"
      />
    ),
    dataIndex: 'applicationId',
    key: 'applicationId',
    render: (_: unknown, record: Record<string, unknown>) => {
      const applicationId = getApplicationId(record);
      return <CellText>{applicationId ?? longdash}</CellText>;
    },
    width: 160,
  };
}

export default applicationIdCell;
